// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__vkWcb","spin":"Spinner_spin__uv1SJ"};